import styles from "./LoadingScreen.tsx.module.css";

export function LoadingScreen() {
  return (
    <>
      <div className={styles.overlay}>
        <span className={styles.loader} />
      </div>
    </>
  );
}
